import * as React from "react";

const JSONFormatter: React.FunctionComponent = () => {
    return (
        <p>JSON Formatter (WIP)</p>
    );
};

export default JSONFormatter;